export default "__VITE_ASSET__oNCRhI92__"